var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentAlertFlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 7.39598C15.2685 7.27654 15.1401 7.20156 15 7.20158H9.46798L10.866 1.1579C10.9052 0.990662 10.8162 0.820061 10.6532 0.750114C10.4901 0.680167 10.2983 0.73028 10.1947 0.869896L2.69473 10.9499C2.6116 11.0597 2.59984 11.205 2.66434 11.3258C2.72883 11.4466 2.8586 11.5223 2.99998 11.5216H8.53198L7.13398 17.5624C7.09474 17.7296 7.18377 17.9002 7.3468 17.9702C7.50983 18.0401 7.70162 17.99 7.80523 17.8504L15.3052 7.77038C15.3869 7.66045 15.3976 7.5159 15.333 7.39598Z",
    fill: "#F4F4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentAlertFlashIcon);
export default __webpack_public_path__ + "static/media/RecentAlertFlashIcon.9975658f0d1380fb0c7b6ede59c141dd.svg";
export { ForwardRef as ReactComponent };